/*@flow*/
import React, { useState, createRef } from 'react';
import { EmailT } from 'types/tcomb';
import * as t from 'lib/t';
import { Fields } from 'lib/proforma';
import api from 'lib/api';

const formType = t.struct({
  password_reset: t
    .struct({
      email: EmailT.options({ type: 'email' }),
    })
    .options({
      legend: '',
    }),
});

const ErrorsView = ({ errors }) =>
  errors && errors.length > 0 ? (
    <ul
      data-testid="ErrorsView"
      className="alert alert-danger list-unstyled pb-1"
    >
      {errors.map((e, i) => (
        <li key={i}>{e}</li>
      ))}
    </ul>
  ) : null;

const CheckYourEmail = () => (
  <div
    data-testid="CheckYourEmail"
    style={{ height: 300 }}
    className="text-flex-center h2"
  >
    <div className="text-center">
      <p className="mb-4">Check your email.</p>
      <i className="fa fa-envelope" />
    </div>
  </div>
);

type FormValue = { password_reset: { email: string } };

type PropsT = {
  errors?: string[],
  value?: FormValue,
  mode: 'SUCCESS' | 'READY',
};

const Component = (props: PropsT) => {
  const [errors, setErrors] = useState(props.errors || []);
  const [value, setValue] = useState(props.value || { password_reset: {} });
  const [mode, setMode] = useState(props.mode || 'READY');
  const form = createRef();

  const onError = (e: { errors: string[] }) => {
    setErrors(e.errors);
  };
  const resetPassword = (body) => {
    api
      .fetchJson('/password_reset', {
        method: 'POST',
        body,
      })
      .then(() => setMode('SUCCESS'), onError)
      .catch(onError);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!form.current) return;
    const v = form.current.getValue();
    if (!v) return;
    resetPassword({ user: v.password_reset });
  };

  if (mode === 'SUCCESS') return <CheckYourEmail />;

  return (
    <form data-testid="PasswordReset" className="form mt-4" onSubmit={onSubmit}>
      <ErrorsView errors={errors} />
      <Fields
        ref={(el) => {
          if (el) form.current = el;
        }}
        type={formType}
        defaultValue={value}
        onChange={(v) => setValue(v)}
      />
      <button
        data-testid="SubmitBtn"
        type="submit"
        className="btn btn-block btn-primary"
      >
        Send me new password
      </button>
    </form>
  );
};
export default (Component: any);
